import React from "react";
import { get } from "lodash";
import { Show, useTranslate } from "react-admin";
import { Flex, Box } from "rebass";
import { Title, ListUrlButton } from "../components";
import { ShowFormFields } from "./components_po";
const ActionForm = (props) => {
  const translate = useTranslate();
  const { pt = 3 } = props;
  return (
    <Flex
      flexDirection={"row"}
      justifyContent={"space-between"}
      width={[1]}
      pt={[pt]}
      pb={[2]}
    >
      <Box width={[1]}>
        <Title fontWeight={"bold"} fontSize={[3]}>
          {translate(props.title)}
          {` ${get(props, "data.po_number", "")}`}
        </Title>
      </Box>
      <Flex width={[1]} flexDirection={"row"} justifyContent={"flex-end"}>
        <ListUrlButton basepath={props.basePath} record={props.data} />
      </Flex>
    </Flex>
  );
};
const OrdersShow = (props) => {
  // console.log(props)
  const { hasList, hasShow, hasEdit, ...rest } = props;
  return (
    <Show
      {...rest}
      actions={<ActionForm title={"resources.po.title"} />}
      component={"div"}
    >
      <ShowFormFields {...rest} />
    </Show>
  );
};

export default OrdersShow;
